module.exports = __webpack_public_path__ + "static/media/1-1.c705432a.png";